<template>
  <div>
    <AddAttachmentDropdown @select="setSelectedOption" />
    <Portal to="app-dialog">
      <VModal v-if="show" ref="modal" @modal:hidden="closeModal">
        <BaseCard v-if="option === 'local-file'" class="max-w-lg w-full mx-auto" @click.stop>
          <BaseCardHeader> Upload a local file </BaseCardHeader>
          <BaseCardBody>
            <CreateTaskMedia
              :task-id="taskId"
              @uploading="
                () => {
                  loading = true;
                }
              "
              @uploaded="
                () => {
                  loading = false;
                  closeModal();
                }
              "
            />
          </BaseCardBody>
        </BaseCard>

        <BaseCard v-if="option === 'external-url'" class="max-w-lg w-full mx-auto" @click.stop>
          <BaseCardHeader> Add an external link </BaseCardHeader>
          <BaseCardBody>
            <CreateTaskLink :submit="createLinkAttachment" />
          </BaseCardBody>
        </BaseCard>

        <BaseCard v-if="option === 'note'" class="max-w-lg w-full mx-auto" @click.stop>
          <BaseCardHeader> Add an external link </BaseCardHeader>
          <BaseCardBody>
            <CreateTaskNote :submit="createNoteAttachment" />
          </BaseCardBody>
        </BaseCard>

        <BaseCard v-if="option === 'example'" class="max-w-lg w-full mx-auto" @click.stop>
          <BaseCardHeader> Add from examples </BaseCardHeader>
          <BaseCardBody>
            <ExamplesManager
              :create-link="createLinkAttachment"
              :create-note="createNoteAttachment"
            />
          </BaseCardBody>
        </BaseCard>
      </VModal>
    </Portal>
  </div>
</template>

<script>
import AddAttachmentDropdown from './attachmentManager/AddAttachmentDropdown.vue';
import CreateTaskMedia from './attachmentManager/CreateTaskMedia.vue';
import CreateTaskLink from './attachmentManager/CreateTaskLink.vue';
import CreateTaskNote from './attachmentManager/CreateTaskNote.vue';
import ExamplesManager from './attachmentManager/ExamplesManager.vue';

export default {
  components: {
    AddAttachmentDropdown,
    CreateTaskMedia,
    CreateTaskLink,
    CreateTaskNote,
    ExamplesManager,
  },
  props: {
    taskId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      show: false,
      option: null,
      loading: false,
    };
  },
  methods: {
    setSelectedOption(option) {
      this.option = option;
      this.show = true;
    },
    async createLinkAttachment(formData) {
      try {
        this.loading = true;

        await this.$store.dispatch({
          type: 'ui/taskLinks/store',
          taskId: this.taskId,
          formData,
        });

        this.closeModal();

        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      } finally {
        this.loading = false;
      }
    },
    async createNoteAttachment(formData) {
      try {
        this.loading = true;

        await this.$store.dispatch({
          type: 'ui/taskNotes/store',
          taskId: this.taskId,
          formData,
        });

        this.closeModal();

        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      } finally {
        this.loading = false;
      }
    },
    closeModal() {
      this.show = false;
      this.option = null;
    },
  },
};
</script>
